import s from './ModalLanguageList.module.css'
import languages from "./languages-data";

import itemBgActive from "../../assets/images/lang_bg_active.webp"
import itemBg from "../../assets/images/lang_bg.webp"
import SimpleButton from "../common/SimpleButton";

import { RootState } from "../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import { i18n } from "@lingui/core";

interface ModalLanguageListProps {
    closeModal: () => void;
}

const ModalLanguageList: React.FC<ModalLanguageListProps> = ({ closeModal }) => {
    const dispatch = useDispatch();
    const selectedLanguage = useSelector((state: RootState) => state.game.user.app_language || "en");

    const changeLanguage = (language: string) => {
        if (language !== selectedLanguage) {
            i18n.activate(language);
            dispatch({ type: 'game/setLanguageCode', payload: language });
            closeModal();
        }
    };

    const currentLanguage = languages.find(({ language }) => language === selectedLanguage) || languages[0];

    return (
        <div className={s.container}>
            <SimpleButton className={s.langButton} onClick={() => closeModal()}>
                <img className={s.imgLangButton} src={currentLanguage.imgPath} alt="flag" />
                <p className={s.langButtonText}>{currentLanguage.title}</p>
            </SimpleButton>

            {languages.map(({ language, imgPath, title }, index) => {
                const isActive = selectedLanguage === language;
                const itemClass = isActive ? `${s.item} ${s.itemActive}` : s.item;
                const titleClass = isActive ? `${s.title} ${s.titleActive}` : s.title;
                return (
                    <div
                        key={index}
                        className={itemClass}
                        onClick={() => changeLanguage(language)}
                        style={{
                            backgroundImage: `url(${isActive ? itemBgActive : itemBg})`,
                        }}
                    >
                        <img className={s.imgFlag} src={imgPath} alt={`${title} flag`} />
                        <p className={titleClass}>{title}</p>
                    </div>
                );
            })}
        </div>
    )
}

export default ModalLanguageList